import { render } from "./ValidationInfoMsg.vue?vue&type=template&id=4a079223"
import script from "./ValidationInfoMsg.vue?vue&type=script&lang=js"
export * from "./ValidationInfoMsg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__